<form [formGroup]="printForm" soho-busyindicator class="pdf-action-form" [ngClass]="{'form-layout-compact': useCompactFormLayout}">
  @if (useTabs) {
    @if (true) {
      <div>
        <div  class="pdf-tab-row">
          <div class="pdf-criteria field">
            <label for="name">{{'Name' | translate}}</label>
            <input formControlName="name" type="text" id="name" data-automation-id="lm-print-to-pdf-name" maxlength="40" soho-trackdirty/>
          </div>
          <div class="pdf-criteria field only-alert">
            <label for="recordLimitAlert"></label>
            <span id="recordLimitAlert" soho-alert data-automation-id="lm-print-to-pdf-record-limit-alert"></span>
          </div>
        </div>
      </div>
    }
    <div soho-tabs>
      <div soho-tab-list-container>
        <ul soho-tab-list>
          <li soho-tab [hidden]="false">
            <a soho-tab-title tabId="tabs-pdf-display" data-automation-id="lm-print-to-pdf-display-tab">{{'PDFDisplayTab' | translate}}</a>
          </li>
          <li soho-tab [hidden]="pdfType === 'regularFormPdf'">
            <a soho-tab-title tabId="tabs-pdf-content" data-automation-id="lm-print-to-pdf-content-tab">{{'PDFContentTab' | translate}}</a>
          </li>
          <li soho-tab [hidden]="!isUseAllActorGroups">
            <a soho-tab-title tabId="tabs-pdf-sharing" data-automation-id="lm-print-to-pdf-sharing-tab">{{'PDFSharingTab' | translate}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div soho-tab-panel tabId="tabs-pdf-display">
      @if (true) {
        <div class="pdf-tab-content">
          <div class="pdf-tab-row">
            <div class="field field-radio pdf-criteria">
              <input formControlName="orientation" type="radio" class="radio field" id="landscape" data-automation-id="lm-print-to-pdf-landscape-orientation" [value]="'landscape'" soho-trackdirty />
              <label for="landscape" class="radio-label">{{'PDFOrientationLandscape' | translate}}</label>
              <input formControlName="orientation" type="radio" class="radio field" id="portrait" data-automation-id="lm-print-to-pdf-portrait-orientation" [value]="'portrait'" soho-trackdirty />
              <label for="portrait" class="radio-label">{{'PDFOrientationPortrait' | translate}}</label>
            </div>
          </div>
          <div class="pdf-tab-row">
            <div class="pdf-criteria field">
              <label soho-label for="pageSize">{{'PDFPageSize' | translate}}</label>
              <select formControlName="pdfPageSize" soho-dropdown id="pageSize" data-automation-id="lm-print-to-pdf-page-size" noSearch soho-trackdirty class="dropdown-md">
                @for (option of pdfSizeData; track option) {
                  <option [value]="option.value">{{option.description}}</option>
                }
              </select>
              @if (pdfPageSize.value === 'Custom') {
                <div id="info-custom" class="info-message" data-automation-id="lm-print-to-pdf-custom-info">
                  <svg class="icon-info icon" focusable="false" aria-hidden="true" role="presentation">
                    <use href="#icon-info"></use>
                  </svg>
                  <pre class="audible">Info</pre>
                  <p class="message-text">{{'PageSizeMaximumDigits' | translate}}</p>
                </div>
              }
            </div>
            @if (showCustomPageSize) {
              <div class="field pdf-criteria">
                <label soho-label for="customWidth" [required]="true">{{'PageWidth' | translate}}</label>
                <input formControlName="pdfPageWidth" id="customWidth" data-automation-id="lm-print-to-pdf-custom-width" soho-trackdirty class="input-sm"/>
                @if (((pdfPageWidth.dirty || pdfPageWidth.touched) && pdfPageWidth.errors)) {
                  <div id="width-error" class="error-message" data-automation-id="lm-print-to-pdf-width-alert">
                    <svg class="icon-error icon" focusable="false" aria-hidden="true" role="presentation">
                      <use href="#icon-error"></use>
                    </svg>
                    <pre class="audible">Error</pre>
                    @if (pdfPageWidth.errors?.required) {
                      <p class="message-text">{{'PageWidthIsRequiredErrorMessage' | translate}}</p>
                    }
                    @if (pdfPageWidth.errors?.pattern || pdfPageWidth.errors?.min) {
                      <p class="message-text">{{'InvalidSize' | translate}}</p>
                    }
                  </div>
                }
              </div>
            }
            @if (showCustomPageSize) {
              <div class="field pdf-criteria">
                <label soho-label for="customHeight" [required]="true">{{'PageHeight' | translate}}</label>
                <input formControlName="pdfPageHeight" id="customHeight" data-automation-id="lm-print-to-pdf-custom-height" soho-trackdirty class="input-sm"/>
                @if (((pdfPageHeight.dirty || pdfPageHeight.touched) && pdfPageHeight.errors)) {
                  <div id="height-error" class="error-message" data-automation-id="lm-print-to-pdf-height-alert">
                    <svg class="icon-error icon" focusable="false" aria-hidden="true" role="presentation">
                      <use href="#icon-error"></use>
                    </svg>
                    <pre class="audible">Error</pre>
                    @if (pdfPageHeight.errors?.required) {
                      <p class="message-text">{{'PageHeightIsRequiredErrorMessage' | translate}}</p>
                    }
                    @if (pdfPageHeight.errors?.pattern || pdfPageHeight.errors?.min) {
                      <p class="message-text">{{'InvalidSize' | translate}}</p>
                    }
                  </div>
                }
              </div>
            }
            @if (showCustomPageSize) {
              <div class="field pdf-criteria">
                <label soho-label for="unitOfMeasure">{{'UnitOfMeasure' | translate}}</label>
                <select formControlName="pdfPageUOM" soho-dropdown id="unitOfMeasure" data-automation-id="lm-print-to-pdf-unit-of-measure" noSearch soho-trackdirty class="dropdown-sm">
                  <option [value]="'Inch'">{{'PDFPageSizeInches' | translate}}</option>
                  <option [value]="'Centimter'">{{'PDFPageSizeCentimeters' | translate}}</option>
                  <option [value]="'Points'">{{'PDFPageSizePoints' | translate}}</option>
                </select>
              </div>
            }
          </div>
          <div  class="pdf-tab-row">
            <div class="pdf-criteria field">
              <label soho-label for="fontOffsetOption">{{'PDFFontSizeOffset' | translate}}</label>
              <select formControlName="fontOffsetOption" soho-dropdown id="fontOffsetOption" data-automation-id="lm-print-to-pdf-font-offset-option" noSearch soho-trackdirty class="dropdown-md">
                <option [value]="'default'">{{'PDFFontSizeOffsetDefault' | translate}}</option>
                <option [value]="'small'">{{'PDFFontSizeOffsetSmall' | translate}}</option>
                <option [value]="'smaller'">{{'PDFFontSizeOffsetSmaller' | translate}}</option>
                <option [value]="'smallest'">{{'PDFFontSizeOffsetSmallest' | translate}}</option>
                <option [value]="'custom'">{{'PDFFontSizeOffsetCustom' | translate}}</option>
              </select>
            </div>
            @if (showFontOffset) {
              <div class="field pdf-criteria lm-no-label" >
                <label soho-label for="fontOffset"></label>
                <input formControlName="fontOffset" soho-spinbox id="fontOffset" data-automation-id="lm-print-to-pdf-font-offset" data-options="{ min:-5, max:20 }" soho-trackdirty class="input-xs"/>
              </div>
            }
          </div>
          <div class="pdf-tab-row">
            <div class="pdf-criteria field">
              <label soho-label for="lm-print-to-pdf-retention-duration-option">{{'RetentionDuration' | translate}}</label>
              <select formControlName="retentionDurationOption" soho-dropdown id="lm-print-to-pdf-retention-duration-option" data-automation-id="lm-print-to-pdf-retention-duration-option" noSearch soho-trackdirty class="dropdown-md">
                <option [value]="'default'">{{'RetentionDurationOptionDefault' | translate}}</option>
                <option [value]="'one-week'">{{'RetentionDurationOptionWeek' | translate}}</option>
                <option [value]="'one-month'">{{'RetentionDurationOptionMonth' | translate}}</option>
                <option [value]="'one-year'">{{'RetentionDurationOptionYear' | translate}}</option>
                <option [value]="'five-years'">{{'RetentionDurationOptionFiveYear' | translate}}</option>
                <option [value]="'custom'">{{'RetentionDurationOptionCustom' | translate}}</option>
              </select>
            </div>
            @if (showRetentionDuration) {
              <div class="field pdf-criteria lm-no-label" >
                <label soho-label for="lm-print-to-pdf-retention-duration"></label>
                <input formControlName="retentionDuration" soho-spinbox  id="lm-print-to-pdf-retention-duration" data-automation-id="lm-print-to-pdf-retention-duration" data-options="{ min:1, max:9999, step:1 }" soho-trackdirty class="input-sm"/>
              </div>
            }
          </div>
        </div>
      }
    </div>
    <div soho-tab-panel tabId="tabs-pdf-content">
      @if (true) {
        <div class="pdf-tab-content">
          @if (printInfo.includeRecordLimit) {
            <div class="pdf-tab-row">
              <div class="pdf-criteria field">
                <label soho-label for="recordLimitOption">{{'PDFCSVRecordLimit' | translate}}</label>
                <select formControlName="recordLimitOption" soho-dropdown id="recordLimitOption" data-automation-id="lm-print-to-pdf-record-limit-option" noSearch soho-trackdirty class="dropdown-md">
                  <option [value]="'default'">{{'PDFDefaultRecordsOption' | translate}}</option>
                  <option [value]="'all'">{{'PDFAllRecordsOption' | translate}}</option>
                  <option [value]="'large'">{{'PDFLargeRecordsOption' | translate}}</option>
                  <option [value]="'small'">{{'PDFSmallRecordsOption' | translate}}</option>
                  <option [value]="'custom'">{{'PDFCustomRecordsOption' | translate}}</option>
                </select>
              </div>
              @if (showMaxRows) {
                <div class="pdf-criteria field">
                  <label soho-label for="maxRows"></label>
                  <input formControlName="maxRows" #maxRows soho-spinbox data-options="{ min:0, step:100 }" soho-trackdirty id="maxRows" data-automation-id="lm-print-to-pdf-record-max-rows" class="input-sm"/>
                </div>
              }
            </div>
          }
          @if (includePrintOption) {
            <div  class="pdf-tab-row">
              <div class="pdf-criteria field">
                <label soho-label for="printOption">{{'PDFPrintOptions' | translate}}</label>
                <select formControlName="printOption" soho-dropdown id="printOption" data-automation-id="lm-print-to-pdf-print-option" noSearch soho-trackdirty class="dropdown-md">
                  @for (option of printOptions; track option) {
                    <option [value]="option.value">{{option.label}}</option>
                  }
                </select>
              </div>
              @if (isTreeList && showMaxLevels) {
                <div class="pdf-criteria field">
                  <label soho-label for="maxLevels"></label>
                  <input formControlName="maxLevels" #maxLevels soho-spinbox min="1" max="99" soho-trackdirty id="maxLevels" data-automation-id="lm-print-to-pdf-max-levels" class="input-xs"/>
                </div>
              }
            </div>
          }
          @if (includeSearchForm) {
            <div class="pdf-criteria field top-margin">
              <input formControlName="searchForm" soho-checkbox type="checkbox" id="searchForm" data-automation-id="lm-print-to-pdf-include-search-form"soho-trackdirty />
              <label for="searchForm" class="checkbox-label">{{'PDFIncludeSearchForm' | translate}}</label>
            </div>
          }
        </div>
      }
    </div>
    <div soho-tab-panel tabId="tabs-pdf-sharing">
      @if (true) {
        <div class="pdf-tab-content">
          <div  class="pdf-tab-row">
            <div class="field pdf-criteria">
              <lm-lookup-basic #reportDistributionGroup data-automation-id="lm-print-to-pdf-distribution-group"
                [fieldLabel]="reportDistGroupLabel"
                [sourceField]="sourceFieldName"
                (lookupValueChangedEvent) = "reportDistributionGroupChanged($event)">
              </lm-lookup-basic>
            </div>
            <div class="field pdf-criteria" [hidden]="!showDynamicActors">
              <label soho-label for="dynamicActors"
              [required]="atLeastOneDynamicActor">{{dynamicActorsLabel}}</label>
              <lm-list-dropdown #dynamicActorsComponent id="dynamicActors" data-automation-id="lm-print-to-pdf-dynamic-actors"
              [options]="dynamicActorOptions" soho-alert></lm-list-dropdown>
            </div>
          </div>
          <div class="pdf-tab-row">
            @if (showEmptyReportOptions) {
              <div class="pdf-criteria field">
                <label soho-label for="emptyReportOptions">{{'EmptyReportOptions' | translate}}</label>
                <select formControlName="emptyReportOptions" soho-dropdown id="emptyReportOptions" data-automation-id="lm-print-to-pdf-empty-report-option" noSearch soho-trackdirty class="dropdown-md">
                  <option [value]="'default'">{{'SendWithNotification' | translate}}</option>
                  <option [value]="'suppressWithoutNotification'">{{'SuppressWithoutNotification' | translate}}</option>
                  <option [value]="'suppressWithNotification'">{{'SuppressWithNotification' | translate}}</option>
                </select>
              </div>
            }
          </div>
        </div>
      }
    </div>
  } @else {
    @if (true) {
      <div>
        <div  class="pdf-tab-row">
          <div class="pdf-criteria field">
            <label for="name">{{'Name' | translate}}</label>
            <input formControlName="name" type="text" id="name" data-automation-id="lm-print-to-pdf-name" maxlength="40" soho-trackdirty/>
          </div>
          <div class="pdf-criteria field only-alert">
            <label for="recordLimitAlert"></label>
            <span id="recordLimitAlert" soho-alert data-automation-id="lm-print-to-pdf-record-limit-alert"></span>
          </div>
        </div>
      </div>
    }
    @if (true) {
      <div class="pdf-tab-content">
        <div class="pdf-tab-row">
          <div class="field field-radio pdf-criteria">
            <input formControlName="orientation" type="radio" class="radio field" id="landscape" data-automation-id="lm-print-to-pdf-landscape-orientation" [value]="'landscape'" soho-trackdirty />
            <label for="landscape" class="radio-label">{{'PDFOrientationLandscape' | translate}}</label>
            <input formControlName="orientation" type="radio" class="radio field" id="portrait" data-automation-id="lm-print-to-pdf-portrait-orientation" [value]="'portrait'" soho-trackdirty />
            <label for="portrait" class="radio-label">{{'PDFOrientationPortrait' | translate}}</label>
          </div>
        </div>
        <div class="pdf-tab-row">
          <div class="pdf-criteria field">
            <label soho-label for="pageSize">{{'PDFPageSize' | translate}}</label>
            <select formControlName="pdfPageSize" soho-dropdown id="pageSize" data-automation-id="lm-print-to-pdf-page-size" noSearch soho-trackdirty class="dropdown-md">
              @for (option of pdfSizeData; track option) {
                <option [value]="option.value">{{option.description}}</option>
              }
            </select>
            @if (pdfPageSize.value === 'Custom') {
              <div id="info-custom" class="info-message" data-automation-id="lm-print-to-pdf-custom-info">
                <svg class="icon-info icon" focusable="false" aria-hidden="true" role="presentation">
                  <use href="#icon-info"></use>
                </svg>
                <pre class="audible">Info</pre>
                <p class="message-text">{{'PageSizeMaximumDigits' | translate}}</p>
              </div>
            }
          </div>
          @if (showCustomPageSize) {
            <div class="field pdf-criteria">
              <label soho-label for="customWidth" [required]="true">{{'PageWidth' | translate}}</label>
              <input formControlName="pdfPageWidth" id="customWidth" data-automation-id="lm-print-to-pdf-custom-width" soho-trackdirty class="input-sm"/>
              @if (((pdfPageWidth.dirty || pdfPageWidth.touched) && pdfPageWidth.errors)) {
                <div id="width-error" class="error-message" data-automation-id="lm-print-to-pdf-width-alert">
                  <svg class="icon-error icon" focusable="false" aria-hidden="true" role="presentation">
                    <use href="#icon-error"></use>
                  </svg>
                  <pre class="audible">Error</pre>
                  @if (pdfPageWidth.errors?.required) {
                    <p class="message-text">{{'PageWidthIsRequiredErrorMessage' | translate}}</p>
                  }
                  @if (pdfPageWidth.errors?.pattern || pdfPageWidth.errors?.min) {
                    <p class="message-text">{{'InvalidSize' | translate}}</p>
                  }
                </div>
              }
            </div>
          }
          @if (showCustomPageSize) {
            <div class="field pdf-criteria">
              <label soho-label for="customHeight" [required]="true">{{'PageHeight' | translate}}</label>
              <input formControlName="pdfPageHeight" id="customHeight" data-automation-id="lm-print-to-pdf-custom-height" soho-trackdirty class="input-sm"/>
              @if (((pdfPageHeight.dirty || pdfPageHeight.touched) && pdfPageHeight.errors)) {
                <div id="height-error" class="error-message" data-automation-id="lm-print-to-pdf-height-alert">
                  <svg class="icon-error icon" focusable="false" aria-hidden="true" role="presentation">
                    <use href="#icon-error"></use>
                  </svg>
                  <pre class="audible">Error</pre>
                  @if (pdfPageHeight.errors?.required) {
                    <p class="message-text">{{'PageHeightIsRequiredErrorMessage' | translate}}</p>
                  }
                  @if (pdfPageHeight.errors?.pattern || pdfPageHeight.errors?.min) {
                    <p class="message-text">{{'InvalidSize' | translate}}</p>
                  }
                </div>
              }
            </div>
          }
          @if (showCustomPageSize) {
            <div class="field pdf-criteria">
              <label soho-label for="unitOfMeasure">{{'UnitOfMeasure' | translate}}</label>
              <select formControlName="pdfPageUOM" soho-dropdown id="unitOfMeasure" data-automation-id="lm-print-to-pdf-unit-of-measure" noSearch soho-trackdirty class="dropdown-sm">
                <option [value]="'Inch'">{{'PDFPageSizeInches' | translate}}</option>
                <option [value]="'Centimter'">{{'PDFPageSizeCentimeters' | translate}}</option>
                <option [value]="'Points'">{{'PDFPageSizePoints' | translate}}</option>
              </select>
            </div>
          }
        </div>
        <div  class="pdf-tab-row">
          <div class="pdf-criteria field">
            <label soho-label for="fontOffsetOption">{{'PDFFontSizeOffset' | translate}}</label>
            <select formControlName="fontOffsetOption" soho-dropdown id="fontOffsetOption" data-automation-id="lm-print-to-pdf-font-offset-option" noSearch soho-trackdirty class="dropdown-md">
              <option [value]="'default'">{{'PDFFontSizeOffsetDefault' | translate}}</option>
              <option [value]="'small'">{{'PDFFontSizeOffsetSmall' | translate}}</option>
              <option [value]="'smaller'">{{'PDFFontSizeOffsetSmaller' | translate}}</option>
              <option [value]="'smallest'">{{'PDFFontSizeOffsetSmallest' | translate}}</option>
              <option [value]="'custom'">{{'PDFFontSizeOffsetCustom' | translate}}</option>
            </select>
          </div>
          @if (showFontOffset) {
            <div class="field pdf-criteria lm-no-label" >
              <label soho-label for="fontOffset"></label>
              <input formControlName="fontOffset" soho-spinbox id="fontOffset" data-automation-id="lm-print-to-pdf-font-offset" data-options="{ min:-5, max:20 }" soho-trackdirty class="input-xs"/>
            </div>
          }
        </div>
        <div class="pdf-tab-row">
          <div class="pdf-criteria field">
            <label soho-label for="lm-print-to-pdf-retention-duration-option">{{'RetentionDuration' | translate}}</label>
            <select formControlName="retentionDurationOption" soho-dropdown id="lm-print-to-pdf-retention-duration-option" data-automation-id="lm-print-to-pdf-retention-duration-option" noSearch soho-trackdirty class="dropdown-md">
              <option [value]="'default'">{{'RetentionDurationOptionDefault' | translate}}</option>
              <option [value]="'one-week'">{{'RetentionDurationOptionWeek' | translate}}</option>
              <option [value]="'one-month'">{{'RetentionDurationOptionMonth' | translate}}</option>
              <option [value]="'one-year'">{{'RetentionDurationOptionYear' | translate}}</option>
              <option [value]="'five-years'">{{'RetentionDurationOptionFiveYear' | translate}}</option>
              <option [value]="'custom'">{{'RetentionDurationOptionCustom' | translate}}</option>
            </select>
          </div>
          @if (showRetentionDuration) {
            <div class="field pdf-criteria lm-no-label" >
              <label soho-label for="lm-print-to-pdf-retention-duration"></label>
              <input formControlName="retentionDuration" soho-spinbox  id="lm-print-to-pdf-retention-duration" data-automation-id="lm-print-to-pdf-retention-duration" data-options="{ min:1, max:9999, step:1 }" soho-trackdirty class="input-sm"/>
            </div>
          }
        </div>
      </div>
    }
  }

  <!--TAB_CONTENT-->
  <!--NON_TAB_CONTENT-->

  <!--CONTEXT_FORM-->
  <!--DISPLAY_OPTIONS-->
  <!--SHARING_OPTIONS-->
  <!--CONTENT_OPTIONS-->
</form>
<div #modalPlaceholder></div>
